export default (params) => ({
  trigger: {
    name: 'review_panel.select_review_translation_toggle',
    params: params,
  },
  config: {
    schema: {
      type: {
        enum: [
          'enable',
          'disable',
        ],
      },
    },
    event: {
      name: 'select_toggle',
      params: {
        sub_feature: 'review translation toggle',
      },
    },
    nonInt: false,
  },
});
